var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplace2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72168 7.49902C3.1202 7.49902 3.44413 7.82223 3.44434 8.2207V10.1494C3.44434 11.0277 4.15592 11.7402 5.03418 11.7402H11.3838V10.2939L14 12.46L11.3838 14.625V13.1836H5.10059C3.38834 13.1835 2 11.7953 2 10.083V8.2207C2.0002 7.82239 2.32337 7.49927 2.72168 7.49902ZM4.61621 2.94531H10.8994C12.6117 2.94543 14 4.33363 14 6.0459V7.9082C13.9997 8.30647 13.6766 8.62964 13.2783 8.62988C12.8798 8.62988 12.5559 8.30662 12.5557 7.9082V5.97949C12.5557 5.10123 11.8441 4.38867 10.9658 4.38867H4.61621V5.83105L2 3.66504L4.61621 1.5V2.94531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace2);
export default __webpack_public_path__ + "static/media/replace2.59842ba49383b12956007d8522195e4d.svg";
export { ForwardRef as ReactComponent };